// @ts-nocheck
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  CircularProgress,
  Divider,
  Input,
  InputAdornment,
  Rating,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import { Box, Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";
import * as Yup from "yup";
import { CustomTextFiled } from "../../../components/Custom/Input";
import ReusableParentContainer from "../../../components/Custom/ReusableParentContainer";
import {
  getCssVariableHandler,
  getRGBAFromRGBGivenAlphaHandler,
} from "../../../utils/styles/getCssVariables";
import {
  getEmailSanitized,
  phoneNumberFormat,
} from "../../../utils/methods/formatters";
import { AiOutlineDelete } from "react-icons/ai";
import { useFormik } from "formik";
import {
  sendOpportunityAnywayAction,
  sendOpportunityToContractorsAction,
} from "../../../store/actions/eventRequestDetails";
import { ALERT_DIALOG } from "../../../store/constants/auth";
import { FaStar } from "react-icons/fa";
import { apiRequest } from "../../../services/apiService";
import { alertDialogAciton } from "../../../store/actions/auth";
import { Cancel, Close, Delete } from "@mui/icons-material";
import GenericTransparentBtn from "../../../components/Custom/GenericTransparentBtn";
import { getCustomMessages } from "../../../store/actions/configurations";
import _ from "lodash";
import { QuestionMark } from "@mui/icons-material";
import theme from "../../../theme";
import LoadingOverlay from "../../../components/Custom/LoadingOverlay";
import OpportunityContainer from "./OpportunityContainer";
import { AlertDialogForSendOpportunity } from "../../../components/Custom/AlertDialog";
import { getUniversalDateTimeFormat } from "../../../utils/methods/universalDateTimeFormat";
import {
  CustomAirportChip,
  CustomIconButton,
} from "../../../components/Custom/CustomIconButton";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import CustomHelper from "../../../components/Helper/CustomHelper";
import { SendOppToNonUserModal } from "./SendOppToNonUserModal";
import { useState } from "react";
import { SearchOutlined } from "@mui/icons-material";
import ContractorFilter from "../../../components/Filter/ContractorFilter";
import ContractorAirportFilter from "../../../components/Filter/ContractorAirportFilter";
import { addInviteContractorAction } from "../../../store/actions/contractor";
import { StatusBadges } from "../../../components/user/StatusBadges";
import { ContactTool } from "../../../components/Tooltip/ContactTool";
import { FlaggedContractor } from "../../../components/user/FlaggedContractor";
import ProfileImg from "../../../assets/images/profile-picture.png";
import {
  RESTRICT_ALERT_MESSAGE,
  RESTRICT_ALERT_MESSAGE_SEND_OPP,
  UNFLAG_ALERT_MESSAGE,
} from "../../../utils/constants/nmaes";
import { ThirdPartyTag } from "../../../components/Tooltip/ThirdPartyTag";
import { getLocationSuffix } from "../../../utils/country-state-city/methods";
import { getNewlyAssignedContractorColor } from "../../../utils/methods/contractors/contractorUtils";
import { fetchContractorRatingsBatchAction } from "../../../store/actions/contractorRatings";
import { isUserRole } from "../../../utils/methods/storeFunc";
import { USER_ROLES } from "../../../staticData/userRoles";

export function generateHtmlTable(data) {
  if (!data) return null;
  const border = getCssVariableHandler({ variableName: "--primary-pink-hex" });
  // Start creating the HTML string with inline styles
  let html = `
        <table style="border-collapse: collapse; width: 100%; text-align: center; color: white;">
            <thead>
                <tr>
                    <th style="border: 1px solid ${border}; padding: 5px; background-color: #444;">Position Name</th>
                    <th style="border: 1px solid ${border}; padding: 5px; background-color: #444;">Contractor Name</th>
                    <th style="border: 1px solid ${border}; padding: 5px; background-color: #444;">Start Date</th>
                </tr>
            </thead>
            <tbody>
    `;

  // Add table rows dynamically from data
  data?.forEach((item) => {
    html += `
            <tr>
                <td style="border: 1px solid ${border}; padding: 5px;">${item.positionName}${item?.positionOrder ? `-${item?.positionOrder}` : ""}</td>
                <td style="border: 1px solid ${border}; padding: 5px;">${item.name}</td>
                <td style="border: 1px solid ${border}; padding: 5px;">${getUniversalDateTimeFormat({ dateTime: item?.startDate ?? item?.Date })}</td>
            </tr>
        `;
  });

  // Close table body and table tag
  html += `</tbody></table>`;

  // Return the full HTML string
  return html;
}

const Option = ({ option, onClick, selectedContractors }) => {
  const dispatch = useDispatch();

  // Internal Rating (parity with AssignDropdown.tsx:220-227) — superAdmin/admin/coordinator
  // see the contractor's 5-star rating in the picker. It was missing here (task #292).
  const ratingsByContractorId = useSelector(
    (s: any) => s?.contractorRatings?.byContractorId ?? {},
  );
  const canViewInternalRating = isUserRole(
    USER_ROLES.SUPERADMIN,
    USER_ROLES.ADMIN,
    USER_ROLES.COORDINATOR,
  );
  const ratingScore = Number(
    ratingsByContractorId[String(option?._id)]?.score,
  ) || 0;

  // Fetch rating if it's not cached yet (one contractor at a time in the picker;
  // the batch fetch is naturally coalesced by the backend-side dispatch action).
  React.useEffect(() => {
    if (!canViewInternalRating || !option?._id) return;
    if (ratingsByContractorId[String(option._id)] !== undefined) return;
    dispatch(fetchContractorRatingsBatchAction({ contractorIds: [option._id] }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [option?._id, canViewInternalRating]);

  const isSelected =
    selectedContractors?.findIndex?.((contractor) => {
      return contractor?._id === option?._id;
    }) > -1;

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  return (
    <>
      <Box
        // {...props}
        sx={{
          width: "100%",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          padding: "8px",
          boxSizing: "border-box",
          background: isSelected
            ? getCssVariableHandler({
                variableName: "--primary-green-rgb",
              })
            : "transparent",
          border: `1px solid ${getCssVariableHandler({
            variableName: "--font-rgb",
          })}`,
          borderRadius: `0.5rem`,
          overflow: "visible",
          cursor: "pointer",
        }}
        className={`autocomplete-option`}
        onMouseDown={(e) => {
          // Clicks inside the contact popover must hit its own buttons
          // (View Documents / Manage Approvals / SMS), not select the row.
          if (e?.target?.closest?.("[data-contact-popover]")) return;
          // if (option?.isContractorFlagged) {
          //   dispatch(
          //     alertDialogAciton({
          //       open: true,
          //       title: "Error",
          //       message: UNFLAG_ALERT_MESSAGE,
          //     }),
          //   );
          //   return;
          // }
          if (option?.isContractorRestricted) {
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Error",
                message: RESTRICT_ALERT_MESSAGE_SEND_OPP,
              }),
            );
            return;
          }
          onClick();
        }}
        data-option={"contractor-search-option"}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "1rem",
            padding: "0 0.5rem",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: isSmallScreen ? "flex-start" : "center",
              gap: "1rem",
            }}
          >
            <Box
              sx={{
                width: "35px",
                height: "35px",
                borderRadius: "50%",
                overflow: "hidden",
              }}
            >
              <img
                src={option?.profileImage || ProfileImg || ""}
                alt={"Profile Image"}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>

            <Box
              sx={{
                flexGrow: "1",
                minWidth: 0,
                // width: "calc(100% - 60px)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "0.85rem",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: isSmallScreen
                      ? "space-between"
                      : "flex-start",
                    gap: "0.5rem",
                    alignItems: "center",
                  }}
                >
                  <ContactTool
                    showName
                    data={{
                      email: option?.email,
                      phone: option?.mobile,
                      name:
                        [option?.firstName, option?.lastName]
                          .filter(Boolean)
                          .join(" ") ||
                        option?.fullName ||
                        option?.email ||
                        "",
                      smsOptedOut: option?.smsOptedOut,
                      smsConsentStatusBySms: option?.smsConsentStatusBySms,
                      smsPermissionStatus: option?.smsPermissionStatus,
                    }}
                    rowData={option}
                  >
                    <Typography
                      variant="span"
                      sx={{
                        color:
                          getNewlyAssignedContractorColor({ data: option }) ||
                          (!option?.isContractorFlagged
                            ? "white"
                            : getCssVariableHandler({
                                variableName: "--red-shade-1rgb",
                              })),
                        margin: "0",
                      }}
                    >
                      {(() => {
                        const name =
                          option?.preferredName ||
                          `${option?.firstName}${option?.middleName ? ` ${option.middleName}` : ""} ${option?.lastName}`.trim();
                        const locationSuffix = getLocationSuffix({
                          state: option?.state,
                          city: option?.city,
                        });
                        return name + locationSuffix;
                      })()}
                      <ThirdPartyTag contractorType={option?.contractorType} />
                    </Typography>
                  </ContactTool>

                  <FlaggedContractor data={option} />
                  {option?.companyName ? (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      <FaStar color="rgb(209, 117, 182)" />
                      <Typography
                        variant="span"
                        sx={{
                          color: "rgb(209, 117, 182)",
                        }}
                      >
                        {option?.companyName}
                      </Typography>
                    </Box>
                  ) : null}
                  {option?.matchReason?.length > 0 ? (
                    <Tooltip
                      componentsProps={{
                        tooltip: {
                          sx: {
                            border: "1px solid gray !important",
                          },
                        },
                        arrow: {
                          sx: {
                            color: "gray",
                            fontSize: "1.5rem",
                          },
                        },
                      }}
                      arrow={true}
                      title={
                        <Box
                          sx={{
                            display: "felx",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                          }}
                        >
                          {option?.matchReason?.map((item, i) => {
                            const [key, value] = item.split(":");
                            if (!key || !value) return null;
                            return (
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "flex-start",
                                }}
                                key={i}
                              >
                                <Typography
                                  sx={{ whiteSpace: "nowrap" }}
                                  color={theme.palette.green.main}
                                >
                                  {key}
                                </Typography>
                                <Typography>&nbsp;:&nbsp;</Typography>
                                <Typography>{value}</Typography>
                              </Box>
                            );
                          })}
                        </Box>
                      }
                    >
                      <Box
                        sx={{
                          height: "1rem",
                          aspectRatio: "1",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: "50%",
                          backgroundColor: "#ffffffc2",
                          cursor: "pointer",
                        }}
                      >
                        <QuestionMark
                          sx={{
                            fontSize: "1rem",
                            color: getCssVariableHandler({
                              variableName: "--primary-pink-hex",
                            }),
                          }}
                        />
                      </Box>
                    </Tooltip>
                  ) : null}

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      justifySelf: "flex-end",
                      marginLeft: "auto",
                      gap: "0.5rem",
                    }}
                  >
                    {/* Internal Rating (5 stars) — fixed-width column so rows align */}
                    {canViewInternalRating && (
                      <Box
                        sx={{
                          width: "92px",
                          flexShrink: 0,
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Rating
                          value={ratingScore}
                          readOnly
                          precision={0.5}
                          size="small"
                          sx={{
                            flexShrink: 0,
                            "& .MuiRating-iconEmpty": {
                              color: "rgba(255,255,255,0.35)",
                            },
                          }}
                        />
                      </Box>
                    )}
                    <StatusBadges cont={option} />
                  </Box>
                </Box>
              </Box>
              {/* <Box */}
              {/*   sx={{ */}
              {/*     display: "flex", */}
              {/*     flexDirection: isSmallScreen ? "column" : "row", */}
              {/*     gap: "0.5rem", */}
              {/*     fontSize: "0.80rem", */}
              {/*     fontWeight: "200", */}
              {/*   }} */}
              {/* > */}
              {/*   <Typography */}
              {/*     variant="span" */}
              {/*     sx={ */}
              {/*       { */}
              {/*         // width: isSmallScreen ? "100%" : "" */}
              {/*       } */}
              {/*     } */}
              {/*   > */}
              {/*     {`Ph.: ${phoneNumberFormat(option?.mobile)}`} */}
              {/*   </Typography> */}
              {/**/}
              {/*   {!isSmallScreen ? ( */}
              {/*     <Divider */}
              {/*       sx={{ */}
              {/*         width: "3px", */}
              {/*         color: getCssVariableHandler({ */}
              {/*           variableName: "--font-rgb", */}
              {/*         }), */}
              {/*         backgroundColor: getCssVariableHandler({ */}
              {/*           variableName: "--font-rgb", */}
              {/*         }), */}
              {/*       }} */}
              {/*       orientation="vertical" */}
              {/*     /> */}
              {/*   ) : null} */}
              {/**/}
              {/* <Typography variant="span">|</Typography> */}
              {/**/}
              {/*   <Typography variant="span"> */}
              {/*     {`Email: ${option?.email}`} */}
              {/*   </Typography> */}
              {/* </Box> */}
            </Box>
          </Box>
        </Box>

        {/* <div>
          <p
            style={{
              margin: '0',
              opacity: '0.5',
              fontSize: '0.85rem',
              color: "rgb(255, 255, 255, 0.75)"
            }}
          >{option?.positionBrief}</p>
        </div> */}
      </Box>
    </>
  );
};

export const CustomMessageOption = ({
  option,
  onClick,
  onMouseDown,
  selectedCustomMessage,
  sx = {},
  showDelete = false,
  deleteFunc = () => {},
  allowSelect = true,
}) => {
  const isSelected = option?._id === selectedCustomMessage?._id;

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <>
      <Box
        // {...props}
        sx={{
          width: "100%",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          padding: "8px",
          boxSizing: "border-box",
          background:
            isSelected && allowSelect
              ? getCssVariableHandler({
                  variableName: "--primary-green-rgb",
                })
              : "transparent",
          borderBottom: `1px solid ${getCssVariableHandler({
            variableName: "--font-rgb",
          })}`,
          borderRadius: `0.5rem`,
          overflow: "visible",
          cursor: "pointer",
          ...sx,
        }}
        className={`autocomplete-option`}
        onClick={onClick}
        data-option={"contractor-search-option"}
        onMouseDown={onMouseDown}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "1rem",
            padding: "0 1rem",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: isSmallScreen ? "flex-start" : "center",
              gap: "1rem",
            }}
          >
            <Box
              sx={{
                flexGrow: "1",
                // width: "calc(100% - 60px)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "0.85rem",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "0.5rem",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="span"
                    sx={{
                      color: "white",
                      margin: "0",
                    }}
                  >{`${option?.message}`}</Typography>
                  {showDelete && (
                    <Cancel
                      sx={{ color: "white", fontSize: "1.25rem" }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        deleteFunc?.();
                      }}
                    />
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

const SendOpportunities = ({
  positionId,
  positionsData,
  sessionId,
  eventInfo,
  timeDiff,
  closeSendOpportunityModalHandler,
}) => {
  // ref start...
  const onMountRef = React.useRef({
    showAddContractorsSearchList: false,
  });
  // ref end...

  // static data start...
  const addContractorsStateInit = React.useMemo(() => {
    return {
      showAddContractorsSearchList: false,
      contractorsSearchListLoading: false,
      addContractorSearchQuery: "",
      addContractorSearchBy: [],
      contractorsSearchList: [],
      selectedContractorsList: [],
      sendOpportunityRequestLoading: false,
    };
  }, []);

  const customMessagesSearchListInit = React.useMemo(() => {
    return {
      data: [],
      filteredData: [],
      show: false,
      selectedMessage: null,
      isLoading: false,
    };
  }, []);

  const initialOppStatus = useMemo(
    () => ({
      status: false,
      message: null,
      title: null,
      onOk: null,
      okLabel: null,
      onClose: null,
      onRefresh: null,
    }),
    [],
  );

  const initialInviteState = useMemo(
    () => ({
      status: false,
    }),
    [],
  );
  const initialAirportFilters = useMemo(() => {
    return {
      localAirports: [],
      additionalAirports: [],
      sameAsLocal: false,
      radius: 50,
      status: false,
    };
  }, []);
  // static data end...

  // media query hooks start...
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  // media query hooks end...

  // React redux hooks start...
  const dispatch = useDispatch();
  // React redux hooks end...

  // state variables start...
  const addContractorsReducer = (state, action) => {
    if (action?.type === "CONTRACTORS_SEARCH_LIST") {
      return {
        ...state,
        contractorsSearchList: action?.payload?.contractorsSearchList,
      };
    } else if (action?.type === "SET_CONTRACTORS_SEARCH_LIST_LOADING") {
      return {
        ...state,
        contractorsSearchListLoading:
          action?.payload?.contractorsSearchListLoading,
      };
    } else if (action?.type === "SET_SHOW_ADD_CONTRACTORS_SEARCH_LIST") {
      return {
        ...state,
        showAddContractorsSearchList:
          action?.payload?.showAddContractorsSearchList,
      };
    } else if (action?.type === "SET_ADD_CONTRACTOR_SEARCH_QUERY") {
      return {
        ...state,
        // contractorsSearchListLoading: true,
        showAddContractorsSearchList: true,
        addContractorSearchQuery: action?.payload?.addContractorSearchQuery,
      };
    } else if (action?.type === "CLEAR_ADD_CONTRACTOR_SEARCH_QUERY") {
      return {
        ...state,
        // contractorsSearchListLoading: true,
        // showAddContractorsSearchList: true,
        addContractorSearchQuery: "",
      };
    } else if (action?.type === "SET_ADD_CONTRACTOR_SEARCH_BY") {
      return {
        ...state,
        addContractorSearchBy: action?.payload?.addContractorSearchBy,
      };
    } else if (action?.type === "SEND_OPPORTUNITY_REQUEST_LOADING") {
      return {
        ...state,
        sendOpportunityRequestLoading:
          action?.payload?.sendOpportunityRequestLoading,
      };
    } else if (action?.type === "STOP_LOADING") {
      return {
        ...state,
        sendOpportunityRequestLoading: false,
      };
    } else if (action?.type === "SELECT_NEW_CONTRACTOR") {
      return {
        ...state,
        selectedContractorsList: [
          ...(state?.selectedContractorsList || []),
          action?.payload?.selectedContractor,
        ],
      };
    } else if (action?.type === "RESET") {
      return {
        ...addContractorsStateInit,
      };
    } else {
      return {
        ...state,
      };
    }
  };

  const [addContractorsState, addContractorsDispatch] = React.useReducer(
    addContractorsReducer,
    addContractorsStateInit,
  );

  const [customMessagesSearchList, setCustomMessagesSearchList] =
    React.useState(customMessagesSearchListInit);
  const [isSearchBarFocussed, setIsSearchBarFocussed] = React.useState(false);
  const [oppStatus, setOppStatus] = React.useState(initialOppStatus);
  const [isInvite, setIsInvite] = useState(initialInviteState);
  const [searchBy, setSearchBy] = React.useState([]);

  // Skill filter: the catalog positions behind the shifts this modal opened with.
  // With it on, the search only returns people who worked or declared that skill,
  // and the list fills in even before typing. FreelanceEC cannot use the crew
  // filters on the backend, so it keeps the plain search.
  const skillOptions = useMemo(
    () =>
      _.uniqBy(
        (positionsData || [])
          .filter((pos) => pos?.positionId)
          .map((pos) => ({
            id: String(pos?.positionId),
            name: pos?.positionName || pos?.positionData?.positionName || "",
          })),
        "id",
      ),
    [positionsData],
  );
  const canFilterBySkill =
    skillOptions.length > 0 &&
    isUserRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN, USER_ROLES.COORDINATOR);
  const [onlySkills, setOnlySkills] = useState(true);
  const filterBySkill = canFilterBySkill && onlySkills;
  const skillIdsParam = filterBySkill
    ? skillOptions.map((sk) => sk.id).sort().join(",")
    : "";
  const [airportFilters, setAirportFilters] = useState(initialAirportFilters);
  const containerRef = React.useRef();
  const [maxVisibleChips, setMaxVisibleChips] = React.useState(2);

  // state variables end...

  // Form schema start...
  const addContractorsFormSchema = Yup.object().shape({
    positionId: Yup.array().min(1),
    sessionId: "",
    opportunities: Yup.array()
      .of(
        Yup.object().shape({
          contractorId: "",
        }),
      )
      .test(
        "at-least-one-contractor",
        "You need to add at least one contractor",
        function (code) {
          return this.parent.opportunities?.length > 0;
        },
      ),
    adminMessage: "",
  });

  function transformOpportunitiesForPayload(data, positionsData) {
    const transformedData = {};

    data?.forEach(({ id: contractorId, Id: positionId }) => {
      if (!transformedData[positionId]) {
        transformedData[positionId] = {
          positionId,
          sessionId: positionsData?.find((pos) => pos?._id === positionId)
            ?.session?._id,
          opportunities: [],
        };
      }

      if (
        !transformedData[positionId].opportunities.some(
          (op) => op.contractorId === contractorId,
        )
      ) {
        transformedData[positionId].opportunities.push({
          contractorId,
          response: { pending: true, applied: false, declined: false },
        });
      }
    });

    return { opportunityData: Object.values(transformedData) };
  }

  const formik = useFormik({
    initialValues: {
      opportunities: [],
      positionId: [],
      sessionId: "",
      adminMessage: "",
    },
    validationSchema: addContractorsFormSchema,
    onSubmit: (values) => {
      const obj = {
        ...values,
        opportunities: values?.opportunities?.map?.((opportunity) => {
          return {
            contractorId: opportunity?._id,
            response: {
              pending: true,
              applied: false,
              declined: false,
            },
          };
        }),
      };

      let payload = {
        opportunityData: [],
      };
      positionsData?.forEach((pos) => {
        payload?.opportunityData?.push({
          positionId: pos?._id,
          sessionId: pos?.session?._id,
          opportunities: [...(obj?.opportunities || [])],
          ...(values?.adminMessage
            ? { adminMessage: values?.adminMessage }
            : {}),
        });
      });

      addContractorsDispatch({
        type: "SEND_OPPORTUNITY_REQUEST_LOADING",
        payload: {
          sendOpportunityRequestLoading: true,
        },
      });

      const sendOppFunc = (newPayload) => {
        // setOppStatus(initialOppStatus);
        // const payload = {
        //   positionId: values?.positionId,
        //   sessionId: values?.sessionId,
        //   opportunities: [...newPayload],
        // };

        // NOTE: in case payload is empty
        if (newPayload?.opportunityData?.length == 0) {
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Alert",
              message: "No position to send opportunity",
            }),
          );
          return;
        }

        addContractorsDispatch({
          type: "SEND_OPPORTUNITY_REQUEST_LOADING",
          payload: {
            sendOpportunityRequestLoading: true,
          },
        });

        dispatch(
          sendOpportunityAnywayAction({
            payload: newPayload,
            sessionId,
            eventId: eventInfo?._id,
            afterRequestCallback: () => {
              addContractorsDispatch({
                type: "SEND_OPPORTUNITY_REQUEST_LOADING",
                payload: {
                  sendOpportunityRequestLoading: false,
                },
              });
            },
            successCallback: (response) => {
              dispatch({
                type: ALERT_DIALOG,
                payload: {
                  open: true,
                  title: "Success!",
                  message: response?.message,
                  onClose: () => {
                    closeSendOpportunityModalHandler();
                  },
                },
              });
            },
          }),
        );
      };

      // NOTE: can add the check if the contractor is working overtime. check api with show modal in the list of names of the contractor.
      function sendOpportunityFirstTime(payload) {
        addContractorsDispatch({
          type: "SEND_OPPORTUNITY_REQUEST_LOADING",
          payload: {
            sendOpportunityRequestLoading: true,
          },
        });
        dispatch(
          sendOpportunityToContractorsAction({
            payload,
            eventId: eventInfo?._id,
            sessionId,
            successCallback: (oldData) => {
              let data = oldData;
              function deleteContractorFromConflict(type, contractorId, posId) {
                switch (type) {
                  case "schedule": {
                    data.scheduledConflict.contractors =
                      data?.scheduledConflict?.contractors?.filter((item) => {
                        return !(
                          item?.id === contractorId && item?.Id === posId
                        );
                      });
                    break;
                  }
                  case "prebook": {
                    data.prebookContractors.contractors =
                      data?.prebookContractors?.contractors?.filter((item) => {
                        return !(
                          item?.id === contractorId && item?.Id === posId
                        );
                      });
                    break;
                  }
                  case "holddown": {
                    data.holdDownContractors.contractors =
                      data?.holdDownContractors?.contractors?.filter((item) => {
                        return !(
                          item?.id === contractorId && item?.Id === posId
                        );
                      });
                    break;
                  }
                  case "warning": {
                    data.warnings.contractors =
                      data?.warnings?.contractors?.filter((item) => {
                        return !(
                          item?.id === contractorId && item?.Id === posId
                        );
                      });
                    break;
                  }
                  default:
                    return;
                }
              }

              if (
                !data?.scheduledConflict &&
                !data?.warnings &&
                !data?.prebookContractors &&
                !data?.holdDownContractors
              ) {
                dispatch(
                  alertDialogAciton({
                    open: true,
                    title: data?.warningData ? "Error" : "Success",
                    message: data?.warningData
                      ? `${data?.warningData?.split(".")[0]} ${data?.count > 0 ? data?.warningData?.split(".")[1] : ""}`
                      : data?.message,
                    onClose: () => {
                      closeSendOpportunityModalHandler();
                    },
                  }),
                );

                // NOTE: condition
              } else if (
                data?.scheduledConflict ||
                data?.warnings ||
                data?.prebookContractors ||
                data?.holdDownContractors ||
                data?.hasRestrictedContractor
              ) {
                let onlyWarning = true;
                let count = 0;
                if (data?.scheduledConflict) {
                  count += 1;
                  onlyWarning = false;
                }
                if (data?.warnings) {
                  count += 1;
                  onlyWarning = false;
                }
                if (data?.prebookContractors) {
                  count += 1;
                  onlyWarning = false;
                }
                if (data?.holdDownContractors) {
                  count += 1;
                  onlyWarning = false;
                }

                setOppStatus({
                  status: true,
                  title: "Warning",
                  message: (
                    <Box>
                      {data?.scheduledConflict && (
                        <OpportunityContainer
                          messageStr={data?.scheduledConflict?.message}
                          title={"Scheduling Conflict Detected"}
                          conflictType={"schedule"}
                          onDelete={deleteContractorFromConflict}
                          contractorsList={data?.scheduledConflict?.contractors}
                          onAnyway={
                            count == 1
                              ? null
                              : () => {
                                  sendOppFunc(
                                    transformOpportunitiesForPayload(
                                      [
                                        ...(data?.scheduledConflict
                                          ?.contractors || []),
                                      ],
                                      positionsData,
                                    ),
                                  );
                                }
                          }
                        />
                      )}

                      {data?.warnings && (
                        <OpportunityContainer
                          title={"Work Hour Limit Exceeded"}
                          messageStr={data?.warnings?.message}
                          contractorsList={data?.warnings?.contractors}
                          conflictType={"warning"}
                          onDelete={deleteContractorFromConflict}
                          onAnyway={
                            count == 1
                              ? null
                              : () => {
                                  sendOppFunc(
                                    transformOpportunitiesForPayload(
                                      [...(data?.warnings?.contractors || [])],
                                      positionsData,
                                    ),
                                  );
                                }
                          }
                        />
                      )}
                      {data?.prebookContractors && (
                        <OpportunityContainer
                          title={"Pre Book Date Conflict"}
                          messageStr={data?.prebookContractors?.message}
                          contractorsList={
                            data?.prebookContractors?.contractors
                          }
                          onAnyway={
                            count == 1
                              ? null
                              : () => {
                                  sendOppFunc(
                                    transformOpportunitiesForPayload(
                                      [
                                        ...(data?.prebookContractors
                                          ?.contractors || []),
                                      ],
                                      positionsData,
                                    ),
                                  );
                                }
                          }
                        />
                      )}

                      {data?.holdDownContractors && (
                        <OpportunityContainer
                          title={"Hold Down Date Conflict"}
                          conflictType={"holddown"}
                          onDelete={deleteContractorFromConflict}
                          messageStr={data?.holdDownContractors?.message}
                          contractorsList={
                            data?.holdDownContractors?.contractors
                          }
                          onAnyway={
                            count == 1
                              ? null
                              : () => {
                                  sendOppFunc(
                                    transformOpportunitiesForPayload(
                                      [
                                        ...(data?.holdDownContractors
                                          ?.contractors || []),
                                      ],
                                      positionsData,
                                    ),
                                  );
                                }
                          }
                        />
                      )}
                      {data?.hasRestrictedContractor && (
                        <OpportunityContainer
                          messageStr={data?.restrictedContractors?.message}
                          title={"Restricted Contractors"}
                          contractorsList={data?.restrictedContractors?.contractors?.map(
                            (item) => {
                              // eslint-disable-next-line
                              const { assignedRoles, ...rest } = item;
                              return rest;
                            },
                          )}
                          conflictType={"Restricted"}
                        />
                      )}
                    </Box>
                  ),
                  okLabel: onlyWarning
                    ? null
                    : count == 1
                      ? "Send Anyway"
                      : "Send Anyway To All",
                  onOk: onlyWarning
                    ? null
                    : () => {
                        sendOppFunc(
                          transformOpportunitiesForPayload(
                            [
                              ...(data?.prebookContractors?.contractors || []),
                              ...(data?.scheduledConflict?.contractors || []),
                              ...(data?.holdDownContractors?.contractors || []),
                              ...(data?.warnings?.contractors || []),
                            ],
                            positionsData,
                          ),
                        );
                      },
                  onClose: () => {
                    addContractorsDispatch({
                      type: "STOP_LOADING",
                    });
                    closeSendOpportunityModalHandler();
                  },
                  onRefresh: () => {
                    sendOpportunityFirstTime(
                      transformOpportunitiesForPayload(
                        [
                          ...(data?.prebookContractors?.contractors || []),
                          ...(data?.scheduledConflict?.contractors || []),
                          ...(data?.holdDownContractors?.contractors || []),
                          ...(data?.warnings?.contractors || []),
                        ],
                        positionsData,
                      ),
                    );
                  },
                });
              }
            },
            afterRequestCallback: () => {
              addContractorsDispatch({
                type: "SEND_OPPORTUNITY_REQUEST_LOADING",
                payload: {
                  sendOpportunityRequestLoading: false,
                },
              });
            },
          }),
        );
      }

      sendOpportunityFirstTime(payload);
    },
  });

  const {
    values,
    setValues,
    handleBlur,
    handleChange,
    touched,
    errors,
    setFieldValue,
    submitForm,
    resetForm,
  } = formik;
  // Form schema end...

  // Handlers start...
  const sendOppToNonUserSubmitHandler = ({
    values,
    beforeCallback,
    successCallback,
    failureCallback,
    afterResponseCallback,
    contractorType,
  }) => {
    // 🔴 Must be a plain object, NOT FormData. `addInviteContractor` reads
    // `@Body()` as JSON and the route has no multipart interceptor, so posting
    // FormData made the body arrive `undefined` on the server: the handler threw
    // "Cannot read properties of undefined (reading 'email')" and the button 500'd
    // every single time. The legacy route parsed multipart with multer
    // (`All_Routes/routesV4.js:673`) and the port dropped it. No file is sent here,
    // only scalar form values, so JSON is all this endpoint ever needed.
    const formData = Object.entries(values || {}).reduce((acc, [key, value]) => {
      acc[key === "phone" ? "mobile" : key] = value;
      return acc;
    }, {});

    delete formData.contractorType;

    if (contractorType) {
      formData.contractorType = contractorType;
    }

    const sendOppFunc = (newPayload) => {
      // NOTE: in case payload is empty
      if (newPayload?.opportunityData?.length == 0) {
        dispatch(
          alertDialogAciton({
            open: true,
            title: "Alert",
            message: "No position to send opportunity",
          }),
        );
        return;
      }

      addContractorsDispatch({
        type: "SEND_OPPORTUNITY_REQUEST_LOADING",
        payload: {
          sendOpportunityRequestLoading: true,
        },
      });

      dispatch(
        sendOpportunityAnywayAction({
          payload: newPayload,
          sessionId,
          eventId: eventInfo?._id,
          afterRequestCallback: () => {
            addContractorsDispatch({
              type: "SEND_OPPORTUNITY_REQUEST_LOADING",
              payload: {
                sendOpportunityRequestLoading: false,
              },
            });
          },
          successCallback: (response) => {
            dispatch({
              type: ALERT_DIALOG,
              payload: {
                open: true,
                title: "Success!",
                message: response?.message,
                onClose: () => {
                  closeSendOpportunityModalHandler();
                },
              },
            });
          },
        }),
      );
    };

    dispatch(
      addInviteContractorAction({
        payload: formData,
        beforeCallback,
        successCallback: ({ response }) => {
          // `addInviteContractor` answers `{ contractorId, invited }`, wrapped by the
          // global ResponseInterceptor into `{ success, status, data }` — so the id
          // lives at `data.data.contractorId`. Reading `data.contractor._id` (a shape
          // the endpoint never returned) sent `contractorId: undefined` downstream and
          // the opportunity was rejected with "opportunityData[] ... required": the
          // contact was created but never got the offer. Nobody had seen it because the
          // request itself used to 500 before reaching this callback.
          const invitedContractorId = response?.data?.data?.contractorId;
          dispatch(
            sendOpportunityToContractorsAction({
              eventId: eventInfo?._id,
              payload: {
                opportunityData: positionId?.map?.((positionId) => {
                  return {
                    opportunities: [
                      {
                        contractorId: invitedContractorId,
                        response: {
                          pending: true,
                          applied: false,
                          declined: false,
                        },
                      },
                    ],
                    positionId,
                    sessionId,
                  };
                }),
              },
              afterRequestCallback: afterResponseCallback,
              successCallback: (oldData) => {
                let data = oldData;
                function deleteContractorFromConflict(
                  type,
                  contractorId,
                  posId,
                ) {
                  switch (type) {
                    case "schedule": {
                      data.scheduledConflict.contractors =
                        data?.scheduledConflict?.contractors?.filter((item) => {
                          return !(
                            item?.id === contractorId && item?.Id === posId
                          );
                        });
                      break;
                    }
                    case "prebook": {
                      data.prebookContractors.contractors =
                        data?.prebookContractors?.contractors?.filter(
                          (item) => {
                            return !(
                              item?.id === contractorId && item?.Id === posId
                            );
                          },
                        );
                      break;
                    }
                    case "holddown": {
                      data.holdDownContractors.contractors =
                        data?.holdDownContractors?.contractors?.filter(
                          (item) => {
                            return !(
                              item?.id === contractorId && item?.Id === posId
                            );
                          },
                        );
                      break;
                    }
                    case "warning": {
                      data.warnings.contractors =
                        data?.warnings?.contractors?.filter((item) => {
                          return !(
                            item?.id === contractorId && item?.Id === posId
                          );
                        });
                      break;
                    }
                    default:
                      return;
                  }
                }

                if (
                  !data?.scheduledConflict &&
                  !data?.warnings &&
                  !data?.prebookContractors &&
                  !data?.holdDownContractors
                ) {
                  dispatch(
                    alertDialogAciton({
                      open: true,
                      title: data?.warningData ? "Error" : "Success",
                      message: data?.warningData
                        ? `${data?.warningData?.split(".")[0]} ${data?.count > 0 ? data?.warningData?.split(".")[1] : ""}`
                        : data?.message,
                      onClose: () => {
                        closeSendOpportunityModalHandler();
                      },
                    }),
                  );

                  // NOTE: condition
                } else if (
                  data?.scheduledConflict ||
                  data?.warnings ||
                  data?.prebookContractors ||
                  data?.holdDownContractors ||
                  data?.hasRestrictedContractor
                ) {
                  let onlyWarning = true;
                  let count = 0;
                  if (data?.scheduledConflict) {
                    count += 1;
                    onlyWarning = false;
                  }
                  if (data?.warnings) {
                    count += 1;
                    onlyWarning = false;
                  }
                  if (data?.prebookContractors) {
                    count += 1;
                    onlyWarning = false;
                  }
                  if (data?.holdDownContractors) {
                    count += 1;
                    onlyWarning = false;
                  }

                  setOppStatus({
                    status: true,
                    title: "Warning",
                    message: (
                      <Box>
                        {data?.scheduledConflict && (
                          <OpportunityContainer
                            messageStr={data?.scheduledConflict?.message}
                            title={"Scheduling Conflict Detected"}
                            conflictType={"schedule"}
                            onDelete={deleteContractorFromConflict}
                            contractorsList={
                              data?.scheduledConflict?.contractors
                            }
                            onAnyway={
                              count == 1
                                ? null
                                : () => {
                                    sendOppFunc(
                                      transformOpportunitiesForPayload(
                                        [
                                          ...(data?.scheduledConflict
                                            ?.contractors || []),
                                        ],
                                        positionsData,
                                      ),
                                    );
                                  }
                            }
                          />
                        )}

                        {data?.warnings && (
                          <OpportunityContainer
                            title={"Work Hour Limit Exceeded"}
                            messageStr={data?.warnings?.message}
                            contractorsList={data?.warnings?.contractors}
                            conflictType={"warning"}
                            onDelete={deleteContractorFromConflict}
                            onAnyway={
                              count == 1
                                ? null
                                : () => {
                                    sendOppFunc(
                                      transformOpportunitiesForPayload(
                                        [
                                          ...(data?.warnings?.contractors ||
                                            []),
                                        ],
                                        positionsData,
                                      ),
                                    );
                                  }
                            }
                          />
                        )}
                        {data?.prebookContractors && (
                          <OpportunityContainer
                            title={"Pre Book Date Conflict"}
                            messageStr={data?.prebookContractors?.message}
                            contractorsList={
                              data?.prebookContractors?.contractors
                            }
                            onAnyway={
                              count == 1
                                ? null
                                : () => {
                                    sendOppFunc(
                                      transformOpportunitiesForPayload(
                                        [
                                          ...(data?.prebookContractors
                                            ?.contractors || []),
                                        ],
                                        positionsData,
                                      ),
                                    );
                                  }
                            }
                          />
                        )}

                        {data?.holdDownContractors && (
                          <OpportunityContainer
                            title={"Hold Down Date Conflict"}
                            conflictType={"holddown"}
                            onDelete={deleteContractorFromConflict}
                            messageStr={data?.holdDownContractors?.message}
                            contractorsList={
                              data?.holdDownContractors?.contractors
                            }
                            onAnyway={
                              count == 1
                                ? null
                                : () => {
                                    sendOppFunc(
                                      transformOpportunitiesForPayload(
                                        [
                                          ...(data?.holdDownContractors
                                            ?.contractors || []),
                                        ],
                                        positionsData,
                                      ),
                                    );
                                  }
                            }
                          />
                        )}
                        {data?.hasRestrictedContractor && (
                          <OpportunityContainer
                            messageStr={data?.restrictedContractors?.message}
                            title={"Restricted Contractors"}
                            contractorsList={data?.restrictedContractors?.contractors?.map(
                              (item) => {
                                // eslint-disable-next-line
                                const { assignedRoles, ...rest } = item;
                                return rest;
                              },
                            )}
                            conflictType={"Restricted"}
                          />
                        )}
                      </Box>
                    ),
                    okLabel: onlyWarning
                      ? null
                      : count == 1
                        ? "Send Anyway"
                        : "Send Anyway To All",
                    onOk: onlyWarning
                      ? null
                      : () => {
                          sendOppFunc(
                            transformOpportunitiesForPayload(
                              [
                                ...(data?.prebookContractors?.contractors ||
                                  []),
                                ...(data?.scheduledConflict?.contractors || []),
                                ...(data?.holdDownContractors?.contractors ||
                                  []),
                                ...(data?.warnings?.contractors || []),
                              ],
                              positionsData,
                            ),
                          );
                        },
                    onClose: () => {
                      addContractorsDispatch({
                        type: "STOP_LOADING",
                      });
                      closeSendOpportunityModalHandler();
                    },
                  });
                }
              },
              failureCallback,
            }),
          );
          // successCallback({
          //   response,
          //   cb: () => {
          //     setIsInvite(isInvite => {
          //       return {
          //         ...isInvite,
          //         status: false
          //       }
          //     })
          //   }
          // });
        },
        failureCallback: ({ error }) => {
          failureCallback({ error });
          afterResponseCallback();
        },
      }),
    );
  };
  // Handlers end...

  // useEffect start...
  React.useEffect(() => {
    if (!containerRef.current) return;

    const observer = new ResizeObserver(() => {
      const containerWidth = containerRef.current.offsetWidth;
      const averageChipWidth = 80; // tweak based on your Chip component (label + padding)
      const calculatedVisibleChips = Math.floor(
        containerWidth / averageChipWidth,
      );
      setMaxVisibleChips(
        calculatedVisibleChips > 0 ? calculatedVisibleChips : 1,
      );
    });

    observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, []);

  React.useEffect(() => {
    setFieldValue("positionId", positionId);

    setFieldValue("sessionId", sessionId);
  }, [positionId, sessionId, setFieldValue]);

  React.useEffect(() => {
    if (!addContractorsState?.addContractorSearchQuery && !skillIdsParam) {
      addContractorsDispatch({
        type: "CONTRACTORS_SEARCH_LIST",
        payload: {
          contractorsSearchList: [],
        },
      });
      addContractorsDispatch({
        type: "SET_CONTRACTORS_SEARCH_LIST_LOADING",
        payload: {
          contractorsSearchListLoading: false,
        },
      });
      addContractorsDispatch({
        type: "SET_SHOW_ADD_CONTRACTORS_SEARCH_LIST",
        payload: {
          showAddContractorsSearchList: false,
        },
      });
      return;
    }

    addContractorsDispatch({
      type: "SET_CONTRACTORS_SEARCH_LIST_LOADING",
      payload: {
        contractorsSearchListLoading: true,
      },
    });

    const debounce = setTimeout(() => {
      (async () => {
        // addContractorsDispatch({
        //   type: "SET_CONTRACTORS_SEARCH_LIST_LOADING",
        //   payload: {
        //     contractorsSearchListLoading: true,
        //   },
        // });

        const { response, error } = await apiRequest({
          method: "GET",
          url: `getAllContractors`,
          params: {
            search: addContractorsState?.addContractorSearchQuery,
            searchBy: searchBy?.join(","),
            searchAirport: [
              ...(airportFilters?.localAirports?.map(
                (item) => item?.airportName,
              ) || []),
              ...(airportFilters?.additionalAirports?.map(
                (item) => item?.airportName,
              ) || []),
            ]?.join(", "),
            ...(searchBy?.find((s) => s == "isFlagged")
              ? { isContractorFlagged: true }
              : {}),
            ...(searchBy?.find((s) => s == "hideFlagged")
              ? { isContractorFlagged: false }
              : {}),
            ...(searchBy?.find((s) => s == "isRestricted")
              ? { isContractorRestricted: true }
              : {}),
            ...(searchBy?.find((s) => s == "hideRestricted")
              ? { isContractorRestricted: false }
              : {}),
            ...(searchBy?.find((s) => s == "isAgreementAccepted")
              ? { isAgreementAccepted: true }
              : {}),
            ...(searchBy?.find((s) => s == "isAgreementPending")
              ? { isAgreementPending: true }
              : {}),
            ...(searchBy?.find((s) => s == "isSMSAccepted")
              ? { isSMSAccepted: true }
              : {}),
            ...(searchBy?.find((s) => s == "isSMSPending")
              ? { isSMSPending: true }
              : {}),
            ...(searchBy?.find((s) => s == "workBookId")
              ? { workBookId: true }
              : {}),
            radius: airportFilters?.radius,
            ...(skillIdsParam ? { positionIds: skillIdsParam } : {}),
            limit: 30,
            page: 1,
          },
          isToken: true,
        });

        addContractorsDispatch({
          type: "SET_CONTRACTORS_SEARCH_LIST_LOADING",
          payload: {
            contractorsSearchListLoading: false,
          },
        });

        if (response) {
          addContractorsDispatch({
            type: "CONTRACTORS_SEARCH_LIST",
            payload: {
              contractorsSearchList: response?.data?.data,
            },
          });
        } else {
          // Error handling...
        }
      })();
    }, [1000]);

    return () => {
      clearTimeout(debounce);
    };
  }, [
    addContractorsState?.addContractorSearchQuery,
    addContractorsState?.addContractorSearchBy,
    searchBy,
    airportFilters,
    skillIdsParam,
  ]);

  React.useEffect(() => {
    dispatch(
      getCustomMessages({
        beforeCallback: () => {
          setCustomMessagesSearchList((customMessagesSearchList) => {
            return {
              ...customMessagesSearchList,
              isLoading: true,
            };
          });
        },
        afterCallback: () => {
          setCustomMessagesSearchList((customMessagesSearchList) => {
            return {
              ...customMessagesSearchList,
              isLoading: false,
            };
          });
        },
        successCallback: ({ res }) => {
          setCustomMessagesSearchList((customMessagesSearchList) => {
            return {
              ...customMessagesSearchList,
              data: res?.data?.data,
              filteredData: res?.data?.data,
            };
          });

          // successCallback ? successCallback({
          //   data: res?.data?.data
          // }) : null;
        },
      }),
    );
  }, []);

  React.useEffect(() => {
    setCustomMessagesSearchList((customMessagesSearchList) => {
      return {
        ...customMessagesSearchList,
        filteredData: customMessagesSearchList?.data?.filter?.((item) => {
          return item?.message
            ?.toLowerCase()
            ?.includes?.(values?.adminMessage?.toLowerCase?.());
        }),
      };
    });
  }, [values?.adminMessage]);

  React.useEffect(() => {
    if (customMessagesSearchList?.selectedMessage?._id) {
      setValues((values) => {
        return {
          ...values,
          adminMessage: customMessagesSearchList?.selectedMessage?.message,
        };
      });
    }
  }, [customMessagesSearchList?.selectedMessage]);

  React.useEffect(() => {
    if (onMountRef.current?.showAddContractorsSearchList) {
      if (
        addContractorsState?.contractorsSearchListLoading ||
        addContractorsState?.contractorsSearchList?.length > 0
      ) {
        addContractorsDispatch({
          type: "SET_SHOW_ADD_CONTRACTORS_SEARCH_LIST",
          payload: {
            showAddContractorsSearchList: true,
          },
        });
      }
    } else {
      onMountRef.current.showAddContractorsSearchList = true;
    }
  }, [addContractorsState?.addContractorSearchBy]);

  return (
    <Box
      sx={{
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",
        height: isSmallScreen ? "90%" : "80%",
      }}
    >
      <ReusableParentContainer
        style={{
          display: oppStatus?.status ? "none" : "flex",
          padding: "30px 20px",
          background: "rgb(0, 0, 0)",
          position: "relative",
          color: getCssVariableHandler({
            variableName: "--font-rgb",
          }),
        }}
      >
        <Box
          sx={{
            width: "95%",
            height: `100%`,
            // padding: '30px 0',
            display: "flex",
            flexDirection: "column",
            // justifyContent: 'center',
            gap: "35px",
            "& > *": {
              width: "100%",
            },
          }}
        >
          <Box
            sx={{
              position: "relative",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "1rem",
              minHeight: "2.5rem",
            }}
          >
            {/* <p /> */}
            <Typography
              variant="h2"
              sx={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                textAlign: "center",
                whiteSpace: "nowrap",
                margin: 0,
              }}
            >
              Send Opportunity
            </Typography>

            {/* NOTE: Invite new contractor */}
            <CustomHelper message={"Send Opportunity to new user"}>
              <CustomIconButton
                sx={{
                  "&:hover": {
                    bgcolor: getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    }),
                  },
                  bgcolor: getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  }),
                }}
                onClick={() =>
                  setIsInvite((prev) => ({ ...prev, status: true }))
                }
              >
                <ContactMailIcon />
              </CustomIconButton>
            </CustomHelper>
          </Box>

          {addContractorsState?.sendOpportunityRequestLoading ? (
            <LoadingOverlay open={true} />
          ) : null}

          <Box>
            <Grid item xs={12}>
              <Box
                // className={styles["form-box"]}
                sx={{
                  position: "relative",
                }}
              >
                {/* <ClickAwayListener
              onClickAway={(e) => {
                addContractorsDispatch({
                  type: "SET_SHOW_ADD_CONTRACTORS_SEARCH_LIST",
                  payload: {
                    showAddContractorsSearchList: false,
                  },
                });
              }}
            > */}
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: "0.5rem",
                    // flexWrap: "wrap",
                  }}
                >
                  <Box
                    sx={{
                      // flex: "0 0 1",
                      // minWidth: "60%",
                      // flex: 1,
                      flexGrow: 1,
                      minWidth: 0,
                      "& .MuiInputBase-root": {
                        background: "rgba(0, 0, 0, 0.01) !important",
                        boxShadow:
                          "0px 0px 30px 0px rgba(209, 117, 182, 0.20) !important",
                        borderRadius: "8px",
                        padding: "5px 24px 5px 7px",
                        "&:before": {
                          content: "none",
                        },
                        "&:after": {
                          content: "none",
                        },
                        "& svg": {
                          color: "#ffffff",
                        },
                        "& input": {
                          color: "#ffffff",
                        },
                      },
                    }}
                  >
                    <Input
                      fullWidth
                      placeholder="Search and Add Contractor"
                      name="addContractor"
                      autoComplete="off"
                      onChange={(e) => {
                        // setAddContractorSearchQuery(e?.target?.value);
                        addContractorsDispatch({
                          type: "SET_ADD_CONTRACTOR_SEARCH_QUERY",
                          payload: {
                            addContractorSearchQuery: e?.target?.value,
                          },
                        });
                      }}
                      // onBlur={handleBlur}
                      value={addContractorsState?.addContractorSearchQuery}
                      sx={{
                        // height: "50px !important",
                        border: "1px solid #FFF !important",
                      }}
                      startAdornment={
                        <SearchOutlined
                          sx={{
                            fontWeight: 300,
                            marginRight: "0.5rem",
                          }}
                        />
                      }
                      endAdornment={
                        <InputAdornment
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: "0.5rem",
                          }}
                          position="start"
                        >
                          {isSearchBarFocussed ? null : (
                            <GenericTransparentBtn
                              onClick={() => {
                                addContractorsDispatch({
                                  type: "CLEAR_ADD_CONTRACTOR_SEARCH_QUERY",
                                });
                              }}
                              style={{
                                background: "grey",
                                padding: "0.10rem",
                                visibility:
                                  addContractorsState?.addContractorSearchQuery
                                    ? "visible"
                                    : "hidden",
                                borderRadius: "50%",
                                onHover: {
                                  background: "grey",
                                  padding: "0.10rem",
                                },
                              }}
                              disabled={
                                addContractorsState?.addContractorSearchQuery
                                  ? false
                                  : true
                              }
                            >
                              <Close
                                sx={{
                                  fontSize: "1rem",
                                  // marginRight: "0.7rem"
                                }}
                              />
                            </GenericTransparentBtn>
                          )}
                          <ContractorFilter
                            filterByOptions={[
                              {
                                label: "Name",
                                value: "name",
                              },
                              {
                                label: "Roles",
                                value: "rolesWorked",
                              },
                              {
                                label: "City",
                                value: "city",
                              },
                              {
                                label: "Certifications",
                                value: "certifications",
                              },
                              {
                                label: "Contractor ID",
                                value: "profileId",
                              },
                              {
                                label: "Workmarket ID",
                                value: "workBookId",
                              },
                              {
                                label: "Exclude Flagged",
                                value: "hideFlagged",
                              },
                              {
                                label: "Exclude Restricted",
                                value: "hideRestricted",
                              },
                              {
                                label: "Only Restricted",
                                value: "isRestricted",
                              },
                              {
                                label: "Only Flagged",
                                value: "isFlagged",
                              },
                              {
                                label: "Accepted Agreement",
                                value: "isAgreementAccepted",
                              },
                              {
                                label: "Pending Agreement",
                                value: "isAgreementPending",
                              },
                              {
                                label: "Accepted SMS Consent",
                                value: "isSMSAccepted",
                              },
                              {
                                label: "Pending SMS Consent",
                                value: "isSMSPending",
                              },
                            ]}
                            onChange={setSearchBy}
                            value={searchBy}
                            onClear={() => {
                              setSearchBy([]);
                            }}
                          />
                        </InputAdornment>
                      }
                      onFocus={() => {
                        setIsSearchBarFocussed(true);
                        addContractorsDispatch({
                          type: "SET_SHOW_ADD_CONTRACTORS_SEARCH_LIST",
                          payload: {
                            showAddContractorsSearchList: true,
                          },
                        });
                      }}
                      onBlur={() => {
                        setIsSearchBarFocussed(false);
                        setTimeout(() => {
                          addContractorsDispatch({
                            type: "SET_SHOW_ADD_CONTRACTORS_SEARCH_LIST",
                            payload: {
                              showAddContractorsSearchList: false,
                            },
                          });
                        }, 50);
                      }}
                    />

                    {addContractorsState?.showAddContractorsSearchList &&
                    (addContractorsState?.contractorsSearchList?.length > 0 ||
                      addContractorsState?.contractorsSearchListLoading ||
                      addContractorsState?.addContractorSearchQuery?.trim() ||
                      filterBySkill) ? (
                      <ReusableParentContainer
                        style={{
                          position: "absolute",
                          height: "fit-content",
                          top: "54px",
                          width: "100% !important",
                          left: "0",
                          background: getCssVariableHandler({
                            variableName: "--bg-theme-rgb",
                          }),
                          padding: "0 !important",
                          zIndex: "10",
                          "@media (max-width: 600px)": {
                            overflowY: "auto !important",
                          },
                        }}
                      >
                        {/* <Box */}
                        {/*   sx={{ */}
                        {/*     display: "flex", */}
                        {/*     justifyContent: "center", */}
                        {/*     alignItems: "center", */}
                        {/*     zIndex: 5, */}
                        {/*     position: "absolute", */}
                        {/*     right: "0", */}
                        {/*     top: "0", */}
                        {/*     transform: `translate(50%, -50%)`, */}
                        {/*     borderRadius: "50%", */}
                        {/*     padding: "0.25rem", */}
                        {/*     background: getCssVariableHandler({ */}
                        {/*       variableName: "--primary-pink-rgb", */}
                        {/*     }), */}
                        {/*   }} */}
                        {/* > */}
                        {/*   <GenericTransparentBtn */}
                        {/*     onClick={() => { */}
                        {/*       addContractorsDispatch({ */}
                        {/*         type: "SET_SHOW_ADD_CONTRACTORS_SEARCH_LIST", */}
                        {/*         payload: { */}
                        {/*           showAddContractorsSearchList: false, */}
                        {/*         }, */}
                        {/*       }); */}
                        {/*     }} */}
                        {/*   > */}
                        {/*     <Close /> */}
                        {/*   </GenericTransparentBtn> */}
                        {/* </Box> */}
                        <Box
                          sx={{
                            position: "relative",
                            width: "100%",
                            maxHeight: "300px",
                            overflowY: "auto",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "5px",
                          }}
                          className={"custom-scroll-design"}
                        >
                          {addContractorsState?.contractorsSearchListLoading ? (
                            <CircularProgress sx={{ my: "1rem" }} size={22} />
                          ) : addContractorsState?.contractorsSearchList
                              ?.length > 0 ? (
                            addContractorsState?.contractorsSearchList?.map?.(
                              (searchedContractor) => {
                                return (
                                  <React.Fragment key={searchedContractor?._id}>
                                    <Option
                                      option={searchedContractor}
                                      onClick={() => {
                                        // if (
                                        //   searchedContractor?.contractorType ===
                                        //     "w2" &&
                                        //   timeDiff > 16
                                        // ) {
                                        //   dispatch(
                                        //     alertDialogAciton({
                                        //       open: true,
                                        //       title: "Error",
                                        //       message:
                                        //         "This opportunity can't be accepted for this contractor, because work hours are more than 16 hours.",
                                        //     }),
                                        //   );
                                        //   return;
                                        // }
                                        // addContractorsDispatch({
                                        //   type: 'ADD_CONTRACTOR',
                                        //   payload: {
                                        //     newContractor: searchedContractor
                                        //   }
                                        // });

                                        const filteredIdx =
                                          values?.opportunities?.findIndex?.(
                                            (addContractor) => {
                                              return (
                                                addContractor?._id ===
                                                searchedContractor?._id
                                              );
                                            },
                                          );

                                        if (filteredIdx < 0) {
                                          setFieldValue("opportunities", [
                                            ...(values?.opportunities || []),
                                            searchedContractor,
                                          ]);

                                          // addContractorsDispatch({
                                          //   type: "SET_SHOW_ADD_CONTRACTORS_SEARCH_LIST",
                                          //   payload: {
                                          //     showAddContractorsSearchList: false,
                                          //   },
                                          // });

                                          addContractorsDispatch({
                                            type: "SELECT_NEW_CONTRACTOR",
                                            payload: {
                                              selectedContractor:
                                                searchedContractor,
                                            },
                                          });
                                        } else {
                                          dispatch({
                                            type: ALERT_DIALOG,
                                            payload: {
                                              open: true,
                                              title: "Error!",
                                              message:
                                                "You already selected this contractor!",
                                            },
                                          });
                                        }
                                      }}
                                      selectedContractors={
                                        values?.opportunities
                                        // addContractorsState?.selectedContractorsList
                                      }
                                    />
                                  </React.Fragment>
                                );
                              },
                            )
                          ) : addContractorsState?.contractorsSearchList
                              ?.length === 0 &&
                            !addContractorsState?.contractorsSearchListLoading &&
                            (addContractorsState?.addContractorSearchQuery?.trim() !==
                              "" ||
                              filterBySkill) ? (
                            <Typography sx={{ my: "1rem" }}>
                              {filterBySkill
                                ? 'No contractors with this skill match. Turn off "Only people with this skill" to search everyone.'
                                : "No Contractors Found"}
                            </Typography>
                          ) : null}
                        </Box>
                      </ReusableParentContainer>
                    ) : null}
                  </Box>

                  {/* NOTE: filters */}
                  <ContractorAirportFilter
                    airportFilters={airportFilters}
                    setAirportFilters={setAirportFilters}
                    showLabel={
                      _.uniqBy(
                        _.concat(
                          airportFilters?.additionalAirports,
                          airportFilters?.localAirports,
                        ),
                      )?.length == 0
                    }
                  />

                  <Box
                    ref={containerRef}
                    sx={{
                      // was flex:"1" — grew even with no airport chips selected,
                      // stealing the row's free space and leaving a gap after the
                      // Airports button. Now it only takes the width of its chips
                      // (0 when empty), so the search bar fills the rest.
                      flex: "0 1 auto",
                      display: "flex",
                      gap: "0.25rem",
                      alignItems: "center",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      minWidth: 0,
                    }}
                  >
                    {(() => {
                      const chips = _.uniqBy(
                        _.concat(
                          airportFilters?.localAirports,
                          airportFilters?.additionalAirports,
                        ),
                        "_id",
                      );
                      const visibleChips = chips.slice(0, maxVisibleChips);
                      const hiddenChips = chips.slice(maxVisibleChips);

                      return (
                        <>
                          {visibleChips.map((item) => (
                            <CustomAirportChip
                              key={item?._id}
                              label={item?.airportCode}
                            />
                          ))}

                          {hiddenChips.length > 0 && (
                            <Tooltip
                              title={
                                <Box>
                                  {hiddenChips.map((item) => (
                                    <Typography key={item?._id}>
                                      {item?.airportCode}
                                    </Typography>
                                  ))}
                                </Box>
                              }
                            >
                              <Typography
                                sx={{
                                  "&:hover": {
                                    textDecoration: "underline",
                                  },
                                  cursor: "pointer",
                                }}
                              >
                                {hiddenChips.length} more
                              </Typography>
                            </Tooltip>
                          )}
                        </>
                      );
                    })()}
                  </Box>
                </Box>
                {/* </ClickAwayListener> */}
                {canFilterBySkill ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: "0.5rem",
                      mt: "0.5rem",
                    }}
                  >
                    <Box
                      component="label"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.4rem",
                        cursor: "pointer",
                        userSelect: "none",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={onlySkills}
                        onChange={(e) => setOnlySkills(e.target.checked)}
                        style={{ accentColor: "rgb(209, 117, 182)", cursor: "pointer" }}
                      />
                      <Typography sx={{ fontSize: "0.85rem" }}>
                        Only people with this skill:
                      </Typography>
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "0.85rem",
                        opacity: onlySkills ? 1 : 0.5,
                        color: "rgb(209, 117, 182)",
                      }}
                    >
                      {skillOptions.map((sk) => sk.name).filter(Boolean).join(", ")}
                    </Typography>
                    {onlySkills ? (
                      <Typography sx={{ fontSize: "0.8rem", opacity: 0.7, width: "100%" }}>
                        Click the search bar to see who matches, or type a name to narrow it down.
                      </Typography>
                    ) : null}
                  </Box>
                ) : null}
              </Box>
            </Grid>
          </Box>

          <Box
            sx={{
              // paddingRight: '8px',
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: "10px",
              // minHeight: '80%',
              maxHeight: "70%",
              overflowY: "auto",
            }}
            className={"custom-scroll-design"}
          >
            {values?.opportunities?.map?.((addContractor) => {
              return (
                <React.Fragment key={addContractor?._id}>
                  <Box
                    sx={{
                      width: "100%",
                      padding: "8px 20px",
                      display: "flex",
                      flexDirection: isSmallScreen ? "column" : "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      color: getCssVariableHandler({
                        variableName: "--font-rgb",
                      }),
                      border: `1px solid ${getRGBAFromRGBGivenAlphaHandler({
                        rgb: getCssVariableHandler({
                          variableName: "--font-rgb",
                        }),
                        alpha: "0.3",
                      })}`,
                      borderRadius: "5px",
                    }}
                  >
                    <Box
                      sx={{
                        width: isSmallScreen ? "100%" : "fit-content",
                        display: "flex",
                        flexDirection: isSmallScreen ? "row" : "column",
                        justifyContent: isSmallScreen
                          ? "space-between"
                          : "flex-start",
                      }}
                    >
                      <ContactTool
                        showName
                        data={{
                          email: addContractor?.email,
                          phone: addContractor?.mobile,
                          name:
                            [addContractor?.firstName, addContractor?.lastName]
                              .filter(Boolean)
                              .join(" ") ||
                            addContractor?.fullName ||
                            addContractor?.email ||
                            "",
                          smsOptedOut: addContractor?.smsOptedOut,
                        }}
                        rowData={addContractor}
                      >
                        <Typography
                          variant="span"
                          sx={{
                            display: "block",
                            fontSize: "20px",
                            fontWeight: "300",
                            color:
                              getNewlyAssignedContractorColor({
                                data: addContractor,
                              }) || "inherit",
                          }}
                        >
                          {(() => {
                            const name =
                              addContractor?.preferredName ||
                              `${addContractor?.firstName}${addContractor?.middleName ? ` ${addContractor.middleName}` : ""} ${addContractor?.lastName}`.trim();
                            const locationSuffix = getLocationSuffix({
                              state: addContractor?.state,
                              city: addContractor?.city,
                            });
                            return name + locationSuffix;
                          })()}
                          <ThirdPartyTag
                            contractorType={addContractor?.contractorType}
                          />
                        </Typography>
                      </ContactTool>

                      <Typography
                        variant="span"
                        sx={{
                          display: "block",
                          fontSize: "15px",
                          fontWeight: "200",
                        }}
                      >
                        {addContractor?.companyName}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        width: isSmallScreen ? "100%" : "fit-content",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: isSmallScreen
                          ? "space-between"
                          : "center",
                        alignItems: "center",
                        gap: "25px",
                        textAlign: "right",
                      }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            textAlign: isSmallScreen ? "left" : "right",
                          }}
                        >
                          {phoneNumberFormat(addContractor?.mobile)}
                        </Typography>
                        <Typography
                          variant="span"
                          sx={{
                            textAlign: isSmallScreen ? "left" : "right",
                          }}
                        >
                          {getEmailSanitized({ email: addContractor?.email }) ||
                            "N/A"}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <Button
                          sx={{
                            minWidth: "0",
                            background: getCssVariableHandler({
                              variableName: "--primary-pink-hex",
                            }),
                            padding: "5px",
                            borderRadius: "5px",
                          }}
                          onClick={() => {
                            setFieldValue(
                              "opportunities",
                              values?.opportunities?.filter?.((contractor) => {
                                return contractor?._id !== addContractor?._id;
                              }),
                            );
                          }}
                        >
                          <AiOutlineDelete size={28} />
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </React.Fragment>
              );
            })}
          </Box>

          <Box
            sx={{
              position: "relative",
              width: "100%",
              marginTop: "auto",
              alignSelf: "flex-end",
            }}
          >
            {customMessagesSearchList?.show ? (
              <ReusableParentContainer
                style={{
                  position: "absolute",
                  height: "auto",
                  // maxHeight: "300px",
                  transform: "translateY(100px)",
                  top: "0",
                  left: "0",
                  width: "100% !important",
                  background: getCssVariableHandler({
                    variableName: "--bg-theme-rgb",
                  }),
                  padding: "0.5rem !important",
                  zIndex: "10",
                  "@media (max-width: 600px)": {
                    overflowY: "auto !important",
                  },
                }}
              >
                {/* <Box */}
                {/*   sx={{ */}
                {/*     display: "flex", */}
                {/*     justifyContent: "center", */}
                {/*     alignItems: "center", */}
                {/*     zIndex: 5, */}
                {/*     position: "absolute", */}
                {/*     right: "0", */}
                {/*     top: "0", */}
                {/*     transform: `translate(50%, -50%)`, */}
                {/*     borderRadius: "50%", */}
                {/*     padding: "0.25rem", */}
                {/*     background: getCssVariableHandler({ */}
                {/*       variableName: "--primary-pink-rgb", */}
                {/*     }), */}
                {/*   }} */}
                {/* > */}
                {/*   <GenericTransparentBtn */}
                {/*     onClick={() => { */}
                {/*       setCustomMessagesSearchList( */}
                {/*         (customMessagesSearchList) => { */}
                {/*           return { */}
                {/*             ...customMessagesSearchList, */}
                {/*             show: false, */}
                {/*           }; */}
                {/*         }, */}
                {/*       ); */}
                {/*     }} */}
                {/*   > */}
                {/*     <Close /> */}
                {/*   </GenericTransparentBtn> */}
                {/* </Box> */}
                <Box
                  sx={{
                    // position: "relative",
                    // position: "absolute",
                    // transform: "translateY(-100%)",
                    // top: "0",
                    // left: "0",
                    width: "100%",
                    height: "auto",
                    maxHeight: "150px",
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "5px",
                    zIndex: "20",
                  }}
                  className={"custom-scroll-design"}
                >
                  {customMessagesSearchList?.isLoading ? (
                    <CircularProgress sx={{ my: "1rem" }} size={22} />
                  ) : customMessagesSearchList?.filteredData?.length > 0 ? (
                    customMessagesSearchList?.filteredData?.map?.(
                      (customMessage) => {
                        return (
                          <React.Fragment key={customMessage?._id}>
                            <CustomMessageOption
                              option={customMessage}
                              onMouseDown={() => {
                                setCustomMessagesSearchList(
                                  (customMessagesSearchList) => {
                                    return {
                                      ...customMessagesSearchList,
                                      selectedMessage: customMessage,
                                    };
                                  },
                                );
                              }}
                              selectedCustomMessage={
                                customMessagesSearchList?.selectedMessage
                                // addContractorsState?.selectedContractorsList
                              }
                              sx={{
                                borderBottom: "1px solid gray",
                                padding: "0.25rem",
                              }}
                            />
                          </React.Fragment>
                        );
                      },
                    )
                  ) : customMessagesSearchList?.data?.length === 0 &&
                    !customMessagesSearchList?.isLoading &&
                    values?.adminMessage?.trim() !== "" ? (
                    <Typography sx={{ my: "1rem" }}>
                      No custom messages found
                    </Typography>
                  ) : null}
                </Box>
              </ReusableParentContainer>
            ) : null}
            <CustomTextFiled
              fullWidth
              placeholder="Message from admin (optional)"
              name="adminMessage"
              onChange={handleChange}
              onFocus={() => {
                setCustomMessagesSearchList((customMessagesSearchList) => {
                  return {
                    ...customMessagesSearchList,
                    show: true,
                  };
                });
              }}
              onBlur={(e) => {
                handleBlur(e);
                setTimeout(() => {
                  setCustomMessagesSearchList((customMessagesSearchList) => {
                    return {
                      ...customMessagesSearchList,
                      show: false,
                    };
                  });
                }, 50);
              }}
              value={values?.adminMessage}
              multiline={true}
              rows={3}
              sx={{
                height: "100px",
              }}
            />
          </Box>

          <Box
            className="bottom-btn-box"
            sx={{
              width: "100%",
              // marginTop: "auto",
              alignSelf: "flex-end",
            }}
          >
            <Button
              className="btn-black"
              sx={{
                width: "50%",
                height: "4.25rem",
              }}
              onClick={() => {
                // setShowAddContractorsModal(false);
                closeSendOpportunityModalHandler();
                addContractorsDispatch({
                  type: "RESET",
                });
                resetForm();
              }}
              // onClick={onClose}
            >
              <Typography className="btn-text">Close</Typography>
            </Button>

            <Button
              className="btn-pink"
              sx={{
                width: "50%",
                height: "4.25rem",
                "&:disabled": {
                  background: "#d85ad8 !important",
                },
              }}
              onClick={() => {
                // setShowAddContractorsModal(false);

                if (errors?.contractors) {
                  // alert(errors?.contractors);
                  dispatch({
                    type: ALERT_DIALOG,
                    payload: {
                      open: true,
                      title: "Error!",
                      message: errors?.contractors,
                    },
                  });
                  return;
                }

                submitForm();
              }}
              disabled={addContractorsState?.sendOpportunityRequestLoading}
              // onClick={onClose}
            >
              <Typography className="btn-text">Send</Typography>
            </Button>
          </Box>
          <AlertDialogForSendOpportunity
            open={oppStatus?.status}
            message={oppStatus?.message}
            title={oppStatus?.title}
            onOk={oppStatus?.onOk}
            okLabel={oppStatus?.okLabel}
            onClose={oppStatus?.onClose}
            handleClose={() => setOppStatus(initialOppStatus)}
            isLoading={addContractorsState?.sendOpportunityRequestLoading}
            onRefresh={oppStatus?.onRefresh}
          />
        </Box>
        {isInvite?.status ? (
          <SendOppToNonUserModal
            open={isInvite?.status}
            handleClose={() => setIsInvite(initialInviteState)}
            isInvite={true}
            onSubmit={sendOppToNonUserSubmitHandler}
          />
        ) : null}
      </ReusableParentContainer>
    </Box>
  );
};

Option.propTypes = {
  option: PropTypes.object,
  onClick: PropTypes.func,
  selectedContractors: PropTypes.array,
};

SendOpportunities.propTypes = {
  positionId: PropTypes.string,
  sessionId: PropTypes.string,
  eventInfo: PropTypes.object,
  timeDiff: PropTypes.number || PropTypes.string,
  closeSendOpportunityModalHandler: PropTypes.func,
  positionsData: PropTypes.array,
};

export default SendOpportunities;